"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
/**
 * Gets the base-64 encoded version of the OTP code.
 *
 * @param code Code string
 * @returns base64 encoded
 */
function getOTPAuthorizationCode(code) {
    return Buffer.from(`${code}`, 'ascii').toString('base64');
}
const isAuthError = (err) => err?.name === 'AuthError';
class AuthAPI {
    client;
    guestAudience;
    constructor(client, guestAudience) {
        this.client = client;
        this.guestAudience = guestAudience;
    }
    /**
     * Sends a register request to the server. You probably don't want to use this
     * directly. Instead, use `useCustomerControl` so we keep track of the
     * returned CSRF token.
     *
     * @param params Register request params
     * @param params.phone User phone number
     * @param params.code Verification code
     * @param params.utm User UTM attributes
     * @param params.email User email
     * @param params.firstName User first name
     * @param params.lastName User last name
     * @param params.referralId User referral ID
     * @param options Request options
     * @param options.csrf CSRF to pass (optional - for mobile only)
     * @returns registration response or error
     */
    async register({ phone, code, utm, email, firstName, lastName, referralId, }, options = {}) {
        if (!code) {
            throw new Error('expected register request to include code');
        }
        const headers = {
            Authorization: `Otp ${getOTPAuthorizationCode(code)}`,
        };
        if (options?.csrf) {
            headers['X-CSRFToken'] = options.csrf;
        }
        try {
            const data = await this.client.post('/auth/register', {
                phone,
                utm,
                email,
                firstName,
                lastName,
                referralId,
            }, {
                headers,
            });
            return {
                data,
            };
        }
        catch (err) {
            if (axios_1.default.isAxiosError(err)) {
                const errRes = err.response?.data;
                if (err.response?.status === 401 && isAuthError(errRes)) {
                    return {
                        error: errRes,
                    };
                }
            }
            throw err;
        }
    }
    /**
     * Sends a login request to the server. You probably don't want to use this
     * directly. Instead, use `useCustomerControl` so we keep track of the
     * returned CSRF token.
     *
     * @param code Verification code
     * @param options Login options
     * @param options.csrf Optional token if verify CSRF token is not a cookie
     * @returns registration response or error
     */
    async login(code, options = {}) {
        try {
            const headers = {
                Authorization: `Otp ${getOTPAuthorizationCode(code)}`,
            };
            if (options?.csrf) {
                headers['X-CSRFToken'] = options.csrf;
            }
            const data = await this.client.post('/auth/login', undefined, {
                headers,
            });
            return {
                data,
            };
        }
        catch (err) {
            if (axios_1.default.isAxiosError(err)) {
                const errRes = err.response?.data;
                if (err.response?.status === 401 && isAuthError(errRes)) {
                    return {
                        error: errRes,
                    };
                }
            }
            throw err;
        }
    }
}
exports.default = AuthAPI;
//# sourceMappingURL=index.js.map